<template>
    
    <v-card >

      <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
        <v-toolbar-title class="headline grey-text">Edit Expense</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="UpdateEditedExpense($v.editExpense)">
          <v-icon color="green">fas fa-check</v-icon>
        </v-btn>
        <v-btn icon @click.native="$router.push({ path: '/dashboard/expense' })">
          <v-icon color="red">fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text style="padding-top: 0;">
        <v-container grid-list-md v-bind:class="{'padContent': !drawer}">
          <v-layout wrap>
            <v-flex x12>
              <v-autocomplete v-bind:items="curriencies"
                              v-model="editExpense.currency"
                              label="Currency"
                              chips
                              :error-messages="currencyErrors"
                              @input="$v.editExpense.currency.$touch(), adjustCurrency()"
                              @blur="$v.editExpense.currency.$touch()"></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Expense Name" v-model="editExpense.expenseName"
                            :error-messages="expenseNameErrors"
                            @input="$v.editExpense.expenseName.$touch()"
                            @blur="$v.editExpense.expenseName.$touch()"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select v-bind:items="account"
                        v-model="editExpense.account"
                        label="Account"
                        auto
                        prepend-icon="fa-balance-scale"
                        hint="What Account does this belong to?"
                        persistent-hint
                        :error-messages="accountErrors"
                        @input="$v.editExpense.account.$touch()"
                        @blur="$v.editExpense.account.$touch()"></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select v-bind:items="budget"
                        v-model="editExpense.budget"
                        label="Budget"
                        chips
                        prepend-icon="fas fa-calculator"
                        hint="What Budget does this belong to?"
                        persistent-hint
                        :error-messages="budgetErrors"
                        @input="$v.editExpense.budget.$touch()"
                        @blur="$v.editExpense.budget.$touch()"></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select v-bind:items="category"
                        v-model="editExpense.category"
                        label="Category"
                        chips
                        prepend-icon="fa-tag"
                        hint="What Category does this belong to?"
                        persistent-hint
                        :error-messages="categoryErrors"
                        @input="$v.editExpense.category.$touch()"
                        @blur="$v.editExpense.category.$touch()"></v-select>
            </v-flex>
            <v-flex xs12 v-if="conversion">
              <v-text-field label="Currency Conversion"
                            prepend-icon="fas fa-balance-scale"
                            v-model="editExpense.currencyConversion"
                            @click.prevent="getCurrencyConvertionRate()"
                            @focus="getCurrencyConvertionRate()"
                            :error-messages="currencyConversionErrors"
                            @input="$v.editExpense.currencyConversion.$touch()"
                            @blur="$v.editExpense.currencyConversion.$touch()"></v-text-field>
              <CurrencyConverter ref="converter" v-on:conversionRate="setCurrencyConversionRate($event)"></CurrencyConverter>
            </v-flex>
            <v-flex xs12 v-if="conversion">
              <v-text-field label="Amount" prepend-icon="fas fa-money-bill" type="number" min="1"
                            v-model="editExpense.foreignCurrencyAmount"
                            :error-messages="foreignCurrencyAmountErrors"
                            @input="$v.editExpense.foreignCurrencyAmount.$touch(), calculateConvertedAmount()"
                            @blur="$v.editExpense.foreignCurrencyAmount.$touch()"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="!conversion">
              <v-text-field label="Expense Amount" prepend-icon="fa-money-bill-alt" type="number" min="1"
                            v-model="editExpense.expenseAmount"
                            :error-messages="expenseAmountErrors"
                            @input="$v.editExpense.expenseAmount.$touch()"
                            @blur="$v.editExpense.expenseAmount.$touch()"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="conversion">
              <v-text-field label="Converted Amount" prepend-icon="fa-money-bill-alt"
                            v-model="editExpense.expenseAmount"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Comment" prepend-icon="fa-comment" v-model="editExpense.comment"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-switch v-model="recurringExpense"
                        label="Recurring Expense"></v-switch>
            </v-flex>
            <v-flex xs6 v-if="!recurringExpense">
              <v-dialog ref="dialog"
                        persistent
                        lazy
                        v-model="editModelExpenseDate"
                        full-width
                        width="290px"
                        :return-value.sync="editExpense.expenseDate">
                <v-text-field slot="activator"
                              label="Expense Date"
                              v-model="editExpense.expenseDate"
                              prepend-icon="event"
                              :error-messages="expenseDateErrors"
                              @input="$v.editExpense.expenseDate.$touch()"
                              @blur="$v.editExpense.expenseDate.$touch()"
                              readonly></v-text-field>
                <v-date-picker v-model="editExpense.expenseDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="editModelExpenseDate = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog.save(editExpense.expenseDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6 v-if="!recurringExpense">
              <v-dialog ref="timemenu"
                        persistent
                        v-model="timemenuvisibilty"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="editExpense.expenseTime">
                <v-text-field slot="activator"
                              label="Time Picker"
                              v-model="editExpense.expenseTime"
                              prepend-icon="access_time"
                              readonly></v-text-field>
                <v-time-picker v-model="editExpense.expenseTime" actions>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="timemenuvisibilty = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.timemenu.save(editExpense.expenseTime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs12 v-if="recurringExpense">
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field label="Repeat Every" type="number" min="1" max="60" v-model="editExpense.repeat"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select v-model="editExpense.cycle"
                            :items="['Day','Week','Month','Year']"></v-select>
                </v-flex>
              </v-layout>
              <v-radio-group v-model="editExpense.period" row>
                <v-radio label="Forever" value="Forever"></v-radio>
                <v-radio label="For Number of cycles" value="For"></v-radio>
              </v-radio-group>
              <v-text-field v-if="editExpense.period === 'For'" label="Number of cycles" type="number" min="1" max="60" v-model="editExpense.numberOfCycles"></v-text-field>
              <v-dialog ref="goesOff"
                        persistent
                        lazy
                        v-model="addModelGoesOff"
                        full-width
                        width="290px"
                        :return-value.sync="editExpense.goesOffFirst">
                <v-text-field slot="activator"
                              label="Start Date"
                              v-model="editExpense.goesOffFirst"
                              prepend-icon="event"
                              readonly></v-text-field>
                <v-date-picker v-model="editExpense.goesOffFirst" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="addModelGoesOff = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.goesOff.save(editExpense.goesOffFirst)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

    </v-card>
    
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'
  
  import { globalFunctions } from '../../javascript/globalFunctions'
  import { accountManager } from '../../javascript/accountManager'
  import { expenseManager } from '../../javascript/expenseManager'

  import currencyConverter from '../../components/reuseable/currencyConverter/currencyConverter.vue'

  export default {
    mixins: [validationMixin],
    components: {
      'CurrencyConverter': currencyConverter
    },
    props: ['drawer'],
    data() {
      return {
        account: [],
        budget: ["None"],
        category: ["cat"],
        curriencies: ["USD", "JMD"],
        OneTime: false,
        Recurring: false,
        recurringExpense: false,
        timemenuvisibilty: false,
        editModelExpenseDate: false,
        editModelGoesOff: false,
        sameExpense: false,
        editExpense: {
          id: 0,
          expenseName: '',
          account: '',
          budget: 'None',
          expenseType: '',
          foreignCurrencyAmount: 0,
          expenseAmount: 0,
          currencyConversion: '',
          currency: '',
          expenseDate: '',
          expenseTime: '',
          comment: '',
          category: '',

          //Recurring
          repeat: 1,
          cycle: '',
          period: 'Forever',
          numberOfCycles: 1,
          goesOffFirst: '',

          //State of Current Object
          objectState: 'New'
        },
        items: []
      }
    },
    computed: {
      expenseNameErrors() {
        const errors = []
        if (!this.$v.editExpense.expenseName.$dirty) return errors
        this.sameExpense && errors.push('A Expense already has this Name. Enter a new Name of update Expense')
        !this.$v.editExpense.expenseName.required && errors.push('Expense Name is required')
        return errors
      },
      accountErrors() {
        const errors = []
        if (!this.$v.editExpense.account.$dirty) return errors
        !this.$v.editExpense.account.required && errors.push('Account is required')
        return errors
      },
      currencyErrors() {
        const errors = []
        if (!this.$v.editExpense.currency.$dirty) return errors
        !this.$v.editExpense.currency.required && errors.push('Currency is required')
        return errors
      },
      currencyConversionErrors() {
        const errors = []
        if (!this.$v.editExpense.currencyConversion.$dirty) return errors
        !this.$v.editExpense.currencyConversion.required && errors.push('Currency Conversion is required')
        return errors
      },
      budgetErrors() {
        const errors = []
        if (!this.$v.editExpense.budget.$dirty) return errors
        !this.$v.editExpense.budget.required && errors.push('Budget is required')
        return errors
      },
      categoryErrors() {
        const errors = []
        if (!this.$v.editExpense.category.$dirty) return errors
        !this.$v.editExpense.category.required && errors.push('Category is required')
        return errors
      },
      foreignCurrencyAmountErrors() {
        const errors = []
        if (!this.$v.editExpense.foreignCurrencyAmount.$dirty && !this.$v.editExpense.foreignCurrencyAmount.$dirty) return errors
        !this.$v.editExpense.foreignCurrencyAmount.minValue && !this.$v.editExpense.foreignCurrencyAmount.minValue && errors.push('Amount must be at least 1')
        return errors
      },
      expenseAmountErrors() {
        const errors = []
        if (!this.$v.editExpense.expenseAmount.$dirty) return errors
        !this.$v.editExpense.expenseAmount.minValue && errors.push('Expense Amount must be at least 1')
        return errors
      },
      expenseDateErrors() {
        const errors = []
        if (!this.$v.editExpense.expenseDate.$dirty) return errors
        !this.$v.editExpense.expenseDate && errors.push('Expense Date is required')
        return errors
      }
    },
    methods: {
      adjustCurrency: function () {
        if (this.editExpense.account !== '') {
          let acc = accountManager.getAccountByName(this.editExpense.account)

          if (this.editExpense.currency === '') {
            this.editExpense.currency = acc.accountCurrency
          }
          else if (this.editExpense.currency !== acc.accountCurrency) {
            this.conversion = true
          }
        }
      },
      getCurrencyConvertionRate: function () {
        this.$refs.converter.showConverter()

        let acc = accountManager.getAccountByName(this.editExpense.account)

        this.$refs.converter.getcurrencyData(this.editExpense.currency, acc.accountCurrency)
      },
      setCurrencyConversionRate: function (data) {
        this.editExpense.currencyConversion = data.conversionRate
      },
      expenseCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if (this.editExpense.expenseAmount <= 0 || !globalFunctions.isIntOrFloat(this.editExpense.expenseAmount) || this.editExpense.expenseAmount === "") { this.editExpense.expenseAmount = 0 }

        if ($v.expenseName.$invalid || $v.category.$invalid || $v.account.$invalid) {
          return false
        }

        if (this.recurringExpense) {
          this.editExpense.expenseType = "Recurring"
        } else if (!this.recurringExpense) {
          this.editExpense.expenseType = "OneTime"
        }

        //for (let i = 0; i < this.items.length; i++) {
        //  if (this.items[i].expenseName.toLowerCase() === this.editExpense.expenseName.toLowerCase() && this.items[i].objectState !== 'Delete') {
        //    this.sameExpense = true
        //    return false
        //  }
        //  if (i === this.items.length - 1) {
        //    this.sameExpense = false
        //  }
        //}

        return true
      },
      UpdateEditedExpense: function ($v) {
        if (this.expenseCheck($v)) {

          this.editExpense.objectState = "Update"

          this.$store.commit('updateExpenseinStore', this.editExpense)

          expenseManager.updateTransactionFromExpense(this.editExpense)

          this.$router.push({ path: '/dashboard/expense' })
        }
      },
      EditExpense: function (item) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === parseInt(item)) {
            let editEntry = JSON.parse(JSON.stringify(this.items[i]))
            this.editExpense = editEntry
            break
          }
        }
        
      },
      setRecurrringSwitch: function () {
        if (this.EditExpense.expenseType === 'Recurring') {
          this.recurringExpense = true
        } else {
          this.recurringExpense = false
        }
      },
      calculateConvertedAmount: function () {
        if (this.editExpense.foreignCurrencyAmount !== 0 && this.editExpense.foreignCurrencyAmount !== '' && this.editExpense.currencyConversion !== '') {
          this.editExpense.expenseAmount = parseFloat(this.editExpense.foreignCurrencyAmount) * parseFloat(this.editExpense.currencyConversion)
        }
        else {
          this.editExpense.expenseAmount = 0
        }
      }
    },
    watch: {
      "editExpense.currencyConversion": function () {
        this.calculateConvertedAmount()
      }
    },
    beforeMount() {

      this.items = this.$store.state.Expenses

      let cat = this.$store.state.Categories
      for (let i = 0; i < cat.length; i++) {
        this.category.push(cat[i].categoryName)
      }

      let acc = this.$store.state.Accounts
      for (let i = 0; i < acc.length; i++) {
        this.account.push(acc[i].accountName)
      }

      let bud = this.$store.state.Budgets
      for (let i = 0; i < bud.length; i++) {
        this.budget.push(bud[i].budgetName)
      }

      this.EditExpense(this.$route.params.itemId)
      this.setRecurrringSwitch()
      this.adjustCurrency()
    },
    validations: {
      editExpense: {
        expenseName: {
          required
        },
        account: {
          required
        },
        currency: {
          required
        },
        currencyConversion: {
          required
        },
        budget: {
          required
        },
        category: {
          required
        },
        foreignCurrencyAmount: {
          required,
          minValue: minValue(1)
        },
        expenseAmount: {
          required,
          minValue: minValue(1)
        },
        expenseDate: {
          required
        }
      }
    }

  }

</script>



// WEBPACK FOOTER //
// src/components/expense/EditExpenses.vue